import React from 'react';
import $ from "jquery";
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import { Input, Grid, Dropdown, Form, TextArea } from 'semantic-ui-react';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

import ReadCookie from '../../../functions/readcookies';
import Loading from '../../loading';
import Server from '../../../functions/server';
import AddJob from './AddJob';

export default class JobCard extends React.Component {

    state = {
        item: {}, operatore: [], newoperator: []
    }

    getJobs = () => {

        let context = this;
        context.setState({ load: true, message: 'Getting Job Cards' })
        $.ajax({
            type: 'POST', data: { 'id': context.props.item.id }, 
            url: Server() + 'Sales/JobCard/getOperator.php',
            success: function (data) {
                console.log(data);
                try {
                    data = JSON.parse(data);
                    context.setState({ operatore: data, load: false, dialog: true })
                } catch (error) {
                    context.setState({ load: false })
                    alert(error)
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    refresh = () => {
        this.props.getJobCardMaster();
        this.setState({ dialog: false })
    }

    deleteSpares = (id) => {
        let context = this;
        context.setState({ load: true, message: 'Edit Spares', })
        $.ajax({
            type: 'POST', data: { id }, url: Server() + 'Sales/JobCard/DeleteOperator.php',
            success: function (data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ load: false })
                    context.refresh();
                }
                else {
                    console.log(data);
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }

    AddOperator = () => {
        let newoperator = this.state.newoperator;
        let i = 1;
        newoperator.map((c) => {
            i = c.id;
        })
        i = 1 + i;
        newoperator.push({ id: i });
        this.setState({ newoperator })
    }

    handleChange1 = (type, id) => event => {
        let newoperator = this.state.newoperator;
        newoperator.map((c) => {
            if (c.id == id) {
                if (type == 'name') {
                    c.name = event.target.value;
                }
                if (type == 'address') {
                    c.address = event.target.value;
                }
                if (type == 'mobile') {
                    c.mobile = event.target.value;
                }
            }
        })
        this.setState({ newoperator })
    }

    deleteitem = (id) => {
        let newoperator = this.state.newoperator;
        let operator = [];
        newoperator.map((c) => {
            if (c.id != id) {
                operator.push(c)
            }
        })
        this.setState({ newoperator: operator })
    }

    submit = () => {
        let context = this;
        let { newoperator } = this.state;
        if (!newoperator) {
            alert('Add operator details');
            return;
        }
        context.setState({ load: true, message: 'Edit Spares', })
        $.ajax({
            type: 'POST', data: { 'operatorDetails': JSON.stringify(newoperator), 'id': this.props.item.id }, 
            url: Server() + 'Sales/JobCard/AddMachineOperator.php',
            success: function (data) {
                console.log(data);
                if (data == 1) {
                    context.setState({ load: false, newoperator: [] })
                    context.refresh();
                }
                else {
                    console.log(data);
                    context.setState({ load: false })
                }
            },
            error: function (e) {
                alert('Try again1!!')
                context.setState({ load: false });
            }
        });
    }


    render() {
        let { dialog, operatore, editDialog, item, load, message, search, newoperator } = this.state;
        let masterItems = this.props.item;
        let i = 1;
        return (
            <div>
                <center>
                    <u onClick={this.getJobs} style={{color: 'blue', cursor: 'pointer'}}>Operator</u>
                </center>
                <Loading load={load} message={message} />
                <Dialog fullWidth={false} maxWidth={'md'} open={dialog}
                    onClose={ () => { this.setState({ dialog: false }) }}>
                    <DialogTitle id="responsive-dialog-title" style={{width: '800px'}}> {"View Operator"} </DialogTitle>
                    <DialogContent>
                        <table width="100%" id="table">
                            <tr>
                                <th id='tableheader'><center>Sino</center></th>
                                <th id='tableheader'><center>Name</center></th>
                                <th id='tableheader'><center>Address</center></th>
                                <th id='tableheader'><center>Mobile</center></th>
                                { masterItems.status != '2' || masterItems.status != 2 ? 
                                    <th id='tableheader'><center>Action</center></th> :
                                    null
                                }
                            </tr>
                            {
                                operatore.map((c) => {
                                    return (
                                        <tr>
                                            <td>{i++}</td>
                                            <td>{c.name}</td>
                                            <td>{c.address}</td>
                                            <td>{c.mobile}</td>
                                            { masterItems.status != '2' || masterItems.status != 2 ? 
                                                <td>
                                                    <div style={{color: 'red', cursor: 'pointer'}} 
                                                        onClick={ () => this.deleteSpares(c.id)}>
                                                        {'Delete'}
                                                    </div>
                                                </td> :
                                                null
                                            }
                                        </tr>
                                    )
                                })
                            }
                            {
                                newoperator.map((c) => {
                                    return (
                                        <tr>
                                            <td>{i++}</td>
                                            <td>
                                                <Input fluid placeholder='Operator Name' value={c.name} 
                                                    onChange={this.handleChange1('name', c.id)} />
                                            </td>
                                            <td>
                                                <Input fluid placeholder='Operator Address' value={c.address} 
                                                    onChange={this.handleChange1('address', c.id)} />
                                            </td>
                                            <td>
                                                <Input fluid placeholder='Operator Mobile' value={c.mobile} 
                                                    onChange={this.handleChange1('mobile', c.id)} />
                                            </td>
                                            <td>
                                                <div style={{color: 'red', cursor: 'pointer'}} 
                                                    onClick={ () => this.deleteitem(c.id)}>
                                                    {'Delete'}
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                        </table>
                        
                        { masterItems.status != '2' || masterItems.status != 2 ?
                            <center><Button onClick={this.AddOperator}>Add Operator</Button></center> :
                            null
                        }
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={this.submit}>Submit</Button>
                        <Button onClick={ () => { this.setState({ dialog: false }) }}>Close</Button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}